import {
  showNotification,
  setSourceUploadStatus
} from '@shoflo/studio-redux/actions';
import { FAILED } from 'constants/SourceUploadStatus';

export default (dispatch, fileName) => () => {
  dispatch(setSourceUploadStatus(fileName, FAILED));
  return dispatch(
    showNotification('Upload Failed', {
      type: 'warning'
    })
  );
};
